/**
 * ============================================================
 * Español
 * ============================================================
 *
 * Translators:
 *
 * Hyuchia <diego@hyuchia.com>
 */

export default {
	'AdvanceHelp': 'Para avanzar en el juego, presiona espacio o haz click',
	'AllowPlayback': 'Click here to allow audio playback',
	'Audio': 'Audio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Activar juego automático',
	'AutoPlaySpeed': 'Velocidad de Juego Automático',

	'Back': 'Atrás',
	'BackButton': 'Atrás',

	'Cancel': 'Cancelar',
	'Close': 'Cerrar',
	'Confirm': '¿Deseas salir?',
	'Credits': 'Créditos',

	'Delete': 'Eliminar',
	'DialogLogButton': 'Mostrar el historial de dialogos',

	'FullScreen': 'Pantalla Completa',

	'Gallery': 'Galería',

	'Help': 'Ayuda',
	'Hide': 'Ocultar',
	'HideButton': 'Esconder el Texto',

	'iOSAudioWarning': 'Las configuraciones de Audio no están disponibles en iOS',

	'KeyboardShortcuts': 'Atajos de Teclado',

	'Language': 'Lenguaje',
	'Load': 'Cargar',
	'LoadAutoSaveSlots': 'Juegos Guardados Automaticamente',
	'LoadButton': 'Abrir la Pantalla de Cargar',
	'Loading': 'Cargando',
	'LoadingMessage': 'Espere mientras se cargan los archivos',
	'LoadSlots': 'Juegos Guardados',
	'LocalStorageWarning': 'El Almacenaje Local no está disponible en este navegador',
	'Log': 'Historial',

	'Music': 'Volumen de la Música',

	'NewContent': 'Un nuevo contenido está disponible, recarga la página para obtener la versión más nueva',
	'NoSavedGames': 'No hay juegos guardados',
	'NoAutoSavedGames': 'No hay juegos guardados automaticamente',
	'NoDialogsAvailable': 'No hay dialogos disponibles. Los dialogos aparecerán aqui una vez que ocurran en el juego',

	'OK': 'Aceptar',
	'OrientationWarning': 'Por favor rota tu dispositivo para jugar',
	'Overwrite': 'Sobreescribir',

	'QuickButtons': 'Botones del Menú Rápido',
	'QuickMenu': 'Menú Rápido',
	'Quit': 'Salir',
	'QuitButton': 'Salir del Juego',

	'Resolution': 'Resolución',

	'Save': 'Guardar',
	'SaveButton': 'Abrir la Pantalla de Guardar',
	'SaveInSlot': 'Guardar en ranura',
	'SelectYourLanguage': 'Selecciona tu idioma',
	'Settings': 'Configuración',
	'SettingsButton': 'Abrir la Pantalla de Configuración',
	'Show': 'Mostrar',
	'Skip': 'Saltar',
	'SkipButton': 'Entrar al modo de salto',
	'SlotDeletion': '¿Está seguro de querer eliminar este juego?',
	'SlotOverwrite': '¿Está seguro de querer Sobreescribir este juego?',
	'Sound': 'Volumen de los Sonidos',
	'Start': 'Comenzar',
	'Stop': 'Detener',

	'TextSpeed': 'Velocidad del Texto',

	'Video': 'Volumen de los Videos',
	'Voice': 'Volumen de la Voz',

	'Windowed': 'Ventana'
};